import React from 'react'
import axios from 'axios'

const {
    REACT_APP_DATABASE_BASEURL_DEV,
    REACT_APP_DATABASE_BASEURL,
    REACT_APP_NODE_ENV
} = process.env;

const getAgeFromDate = (ageToFormat) => {
    const givenDate = new Date(ageToFormat);
    const currentDate = new Date();
    const timeDiff = currentDate - givenDate;
    const years = timeDiff / (1000 * 60 * 60 * 24 * 365.25);
    return Math.round(years)
}

const generateGender = (userGender) => {
    if (userGender === 'muško') {
        return 'M'
    } else if (userGender === 'žensko') {
        return 'Ž'
    } else if (userGender === 'nebinaran') {
        return 'N'
    }
}

const MM = ({
    modalTitle,
    generateHeaderCloseIco,
    currUser,
    socket,
    towns,
    setType,
    me
}) => {

    const [gender, setGender] = React.useState('')
    const [genderToFind, setGenderToFind] = React.useState('')
    const [myAge, setMyAge] = React.useState()
    const [ageFrom, setAgeFrom] = React.useState()
    const [ageTo, setAgeTo] = React.useState()
    const [forWhat, setForWhat] = React.useState('')
    const [town, setTown] = React.useState('')
    const [checkBox, setCheckBox] = React.useState(false)
    const [genderToFindBorder, setGenderToFindBorder] = React.useState('')
    const [ageFromBorder, setAgeFromBorder] = React.useState('')
    const [ageToBorder, setAgeToBorder] = React.useState('')
    const [forWhatBorder, setForWhatBorder] = React.useState('')
    const [townBorder, setTownBorder] = React.useState('')
    const [isInMatchmaking, setIsInMatchmaking] = React.useState(false)
    const [info, setInfo] = React.useState('Što tražite?')
    const [infoColor, setInfoColor] = React.useState('')
    const nums = [18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70]
    const lastLocation = React.useRef(null)
    const firstLocation = React.useRef(null)
    const [regScreen, setRegScreen] = React.useState(1)

    const setRegScreenManualy = (regScreenToSet, infoToSet) => {
        setRegScreen(regScreenToSet)
        setInfo(infoToSet)
    }

    const nextRegScreen = () => {
        setRegScreen(regScreen + 1)
        switch (regScreen + 1) {
            case 1:
                setInfo('Odaberi što tražiš')
                break;
            case 2:
                setInfo('Odaberi za koju aktivnost')
                break;
            case 3:
                setInfo('Odaberi od koliko godina')
                break;
            case 4:
                setInfo('Odaberi do koliko godina')
                break;
            case 5:
                setInfo('Odaberi u kojem mjestu')
                break;
            case 6:
                setInfo('Čekiraj da se slažeš sa uvjetima korištenja')
                break;
        }
    }


    const prevRegScreen = () => {
        setRegScreen(regScreen - 1)
        switch (regScreen - 1) {
            case 1:
                setInfo('Odaberi što tražiš')
                break;
            case 2:
                setInfo('Odaberi za koju aktivnost')
                break;
            case 3:
                setInfo('Odaberi od koliko godina')
                break;
            case 4:
                setInfo('Odaberi do koliko godina')
                break;
            case 5:
                setInfo('Odaberi u kojem mjestu')
                break;
            case 6:
                setInfo('Čekiraj da se slažeš sa uvjetima korištenja')
                break;
        }
    }


    const getCurrUserMM = async () => {
        try {
            const response = await axios.get(`${REACT_APP_NODE_ENV === 'development' ?
                REACT_APP_DATABASE_BASEURL_DEV :
                REACT_APP_DATABASE_BASEURL}/mm-one/${currUser}`)

            if (response.data.status === 1) {
                setIsInMatchmaking(true)
                setGenderToFind(response.data.mm.genderToFind)
                setAgeFrom(response.data.mm.ageFrom)
                setAgeTo(response.data.mm.ageTo)
                setForWhat(response.data.mm.forWhat)
                setTown(response.data.mm.town)
                setCheckBox(false)
                setGenderToFindBorder('orange')
                setAgeFromBorder('orange')
                setAgeToBorder('orange')
                setForWhatBorder('orange')
                setTownBorder('orange')
                setInfo('Izmjenite parametre ili potpuno izađite iz matchmakinga')
                setInfoColor('orange')

            } else {
                setIsInMatchmaking(false)
            }
        } catch (e) {

        }
    }

    React.useEffect(() => {
        getCurrUserMM()
    }, [])

    const handleMMUpdate = async () => {

        const MMupdated = {
            author: currUser,
            avatar: me.avatar,
            gender: generateGender(me.gender),
            myAge: getAgeFromDate(me.birthDate),
            genderToFind,
            ageFrom,
            ageTo,
            town,
            forWhat
        }

        try {
            const response = await axios.put(`${REACT_APP_NODE_ENV === 'development' ?
                REACT_APP_DATABASE_BASEURL_DEV :
                REACT_APP_DATABASE_BASEURL}/mm-update`, MMupdated, {
                headers: {
                    'authorization': localStorage.getItem('token')
                }
            })

            if (response.data.status === 1) {
                setInfo('Uspješno ste ažurirali postavke')
                setInfoColor('mediumaquamarine')
                setCheckBox(false)
                setRegScreen(1)
            }
        } catch (e) {
            console.log(e)
        }
    }

    const handleForWhatChange = (e) => {
        setForWhat(e.target.value)
        setForWhatBorder('MediumAquaMarine')
        //lastLocation.current.scrollIntoView();
    }

    const handleTownsChange = async (e) => {
        setTown(e.target.value)
        setTownBorder('MediumAquaMarine')
    }

    const handleGenderToFindChange = (e) => {
        setGenderToFind(e.target.value)
        setGenderToFindBorder('MediumAquaMarine')
    }

    const handleAgeFromChange = (e) => {
        setAgeFrom(e.target.value)
        setAgeFromBorder('MediumAquaMarine')
    }

    const handleAgeToChange = (e) => {
        setAgeTo(e.target.value)
        setAgeToBorder('MediumAquaMarine')
    }

    const handleLeaveMMNew = () => {
        socket.emit('leaveMMNew', currUser, localStorage.getItem('token'))
        setIsInMatchmaking(false)
        setGenderToFindBorder('')
        setAgeFromBorder('')
        setAgeToBorder('')
        setForWhatBorder('')
        setTownBorder('')
        setGenderToFind('')
        setAgeFrom('')
        setAgeTo('')
        setForWhat('')
        setTown('')
        setCheckBox(false)
        setInfo('Uspješno ste izašli iz matchamakinga.')
        setInfoColor('mediumaquamarine')
        firstLocation.current.scrollIntoView()
        setRegScreen(1)
    }

    const handleMMNewSubmit = (e) => {
        e.preventDefault()

        const newMMnew = {
            author: currUser,
            avatar: me.avatar,
            gender: generateGender(me.gender),
            myAge: getAgeFromDate(me.birthDate),
            genderToFind,
            ageFrom,
            ageTo,
            town,
            forWhat
        }

        localStorage.setItem('newMMnew', JSON.stringify(newMMnew))
        socket.emit('newMMnew', newMMnew, localStorage.getItem('token'))
        setIsInMatchmaking(true)
        setInfo('Ušli ste u matchmaking! Primit ćete notifikaciju za kompatibilni match.')
        setInfoColor('mediumaquamarine')
        setRegScreen(1)
        firstLocation.current.scrollIntoView()
    }

    const handleSetCheckbox = () => {
        setCheckBox(!checkBox)
    }

    const handleOpenModal = () => {
        setType('uvjetiKoristenja')
    }

    const checkFields = () => {

        if (
            genderToFind &&
            ageFrom &&
            ageTo &&
            forWhat &&
            town &&
            checkBox
        ) {
            return false
        }

        return true
    }

    const renderMMNew = () => {

        return (
            <div ref={firstLocation}>
                <form onSubmit={handleMMNewSubmit}>
                    {info.length !== 0 && <p style={{ color: infoColor }} className="text-left margin-top margin-right form-p">{info}</p>}
                    <div className="margin-bottom w100 margin-top">
                        <p className="form-p text-left margin-bottom-5">{`Korak ${regScreen}/6`}</p>
                        <div className="row w100">
                            <div onClick={() => { setRegScreenManualy(1, 'Odaberi što tražiš') }} className={`step-alt2 ${regScreen === 1 && 'step-current'} ${genderToFindBorder === 'MediumAquaMarine' || genderToFindBorder === 'orange' ? 'step-done' : 'step-wrong'} pointer`}></div>
                            <div onClick={() => { setRegScreenManualy(2, 'Odaberi za koju aktivnost') }} className={`step-alt2 ${regScreen === 2 && 'step-current'} ${forWhatBorder === 'MediumAquaMarine' || forWhatBorder === 'orange' ? 'step-done' : 'step-wrong'} pointer`}></div>
                            <div onClick={() => { setRegScreenManualy(3, 'Odaberi od koliko godina') }} className={`step-alt2 ${regScreen === 3 && 'step-current'} ${ageFromBorder === 'MediumAquaMarine' || ageFromBorder === 'orange' ? 'step-done' : 'step-wrong'} pointer`}></div>
                            <div onClick={() => { setRegScreenManualy(4, 'Odaberi do koliko godina') }} className={`step-alt2 ${regScreen === 4 && 'step-current'} ${ageToBorder === 'MediumAquaMarine' || ageToBorder === 'orange' ? 'step-done' : 'step-wrong'} pointer`}></div>
                            <div onClick={() => { setRegScreenManualy(5, 'Odaberi u kojem mjestu') }} className={`step-alt2 ${regScreen === 5 && 'step-current'} ${townBorder === 'MediumAquaMarine' || townBorder === 'orange' ? 'step-done' : 'step-wrong'} pointer`}></div>
                            <div onClick={() => { setRegScreenManualy(6, 'Čekiraj da se slažeš sa uvjetima korištenja') }} className={`step-alt2 ${regScreen === 6 && 'step-current'} ${checkBox && 'step-last'} pointer`}></div>
                        </div>
                    </div>


                    <div className="form-wrap margin-bottom">

                        {regScreen === 1 && <div className="form-item">
                            <select style={{ borderColor: genderToFindBorder }} value={genderToFind} onChange={handleGenderToFindChange} className="mm-input" id="gender" name="gender">
                                <option disabled selected key="0" value="">Tražim:</option>
                                <option key="Ž" value="Ž">žensko</option>
                                <option key="M" value="M">muško</option>
                                <option key="N" value="N">nebinarnog</option>
                            </select>
                            <label className="fw200 faded f12 margin-top-s" htmlFor="gender">Koga tražiš</label>
                            {(genderToFindBorder === 'MediumAquaMarine' || genderToFindBorder === 'orange') && (
                                <p onClick={nextRegScreen} className="text-left pointer form-p margin-top underline mediumaquamarine">
                                    {'Naredni korak >>'}
                                </p>
                            )}
                        </div>}

                        {regScreen === 2 &&
                            <div className="form-item">
                                <select style={{ borderColor: forWhatBorder }} onChange={handleForWhatChange} value={forWhat} className="mm-input" id="forWhat" name="forWhat">
                                    <option disabled selected key="N" value="">Za:</option>
                                    <option key="chat" value="chat">chat</option>
                                    <option key="kavu" value="kavu">kavu</option>
                                    <option key="odlazak u restoran" value="odlazak u restoran">odlazak u restoran</option>
                                    <option key="kino" value="kino">kino</option>
                                    <option key="cbd" value="cbd">zapalit CBD joint</option>
                                    <option key="izlazak" value="izlazak">izlazak</option>
                                    <option key="odlazak na event" value="odlazak na event">odlazak na event</option>
                                    <option key="bavljenje sportom" value="bavljenje sportom">bavljenje sportom</option>
                                    <option key="bavljenje hobbyem" value="bavljenje hobbyem">bavljenje hobbyem</option>
                                    <option key="vezu" value="vezu">vezu</option>
                                    <option key="brak" value="brak">brak</option>
                                    <option key="sex" value="sex">za odlazak u općinu Fuka na PRC event...</option>
                                </select>
                                <label className="fw200 faded f12 margin-top-s" htmlFor="forWhat">Za koju aktivnost</label>
                                <div className="row margin-top">
                                    <p onClick={prevRegScreen} className="text-left pointer form-p underline">{'<< Povratak'}</p>
                                    {(forWhatBorder === 'MediumAquaMarine' || forWhatBorder === 'orange') && (
                                        <p onClick={nextRegScreen} className="text-left  pointer form-p margin-left underline mediumaquamarine">
                                            {'Nastavi >>'}
                                        </p>
                                    )}
                                </div>
                            </div>
                        }

                        {regScreen === 3 &&
                            <div className="form-item">
                                <select style={{ borderColor: ageFromBorder }} value={ageFrom} onChange={handleAgeFromChange} className="mm-input" id="age-from" name="age-from">
                                    <option disabled selected key="N" value="">Od:</option>
                                    {nums.map(num => <option key={num} value={num}>{`${num} god.`}</option>)}
                                </select>
                                <label className="fw200 faded f12 margin-top-s" htmlFor="age-from">Od koliko</label>
                                <div className="row margin-top">
                                    <p onClick={prevRegScreen} className="text-left pointer form-p underline">{'<< Povratak'}</p>
                                    {(ageFromBorder === 'MediumAquaMarine' || ageFromBorder === 'orange') && (
                                        <p onClick={nextRegScreen} className="text-left pointer form-p margin-left underline mediumaquamarine">
                                            {'Nastavi >>'}
                                        </p>
                                    )}
                                </div>
                            </div>
                        }

                        {regScreen === 4 &&
                            <div className="form-item">
                                <select style={{ borderColor: ageToBorder }} value={ageTo} onChange={handleAgeToChange} className="mm-input" id="age-to" name="age-to">
                                    <option disabled selected key="N" value="">Do:</option>
                                    {nums.map(num => <option key={num} value={num}>{`${num} god.`}</option>)}
                                </select>
                                <label className="fw200 faded f12 margin-top-s" htmlFor="age-to">Do koliko godina</label>
                                <div className="row margin-top">
                                    <p onClick={prevRegScreen} className="text-left pointer form-p underline">{'<< Povratak'}</p>
                                    {(ageToBorder === 'MediumAquaMarine' || ageToBorder === 'orange') && (
                                        <p onClick={nextRegScreen} className="text-left pointer form-p margin-left underline mediumaquamarine">
                                            {'Nastavi >>'}
                                        </p>
                                    )}
                                </div>
                            </div>
                        }

                        {regScreen === 5 &&
                            <div className="form-item">
                                <select style={{ borderColor: townBorder }} onChange={handleTownsChange} value={town} className="mm-input" id="towns" name="towns">
                                    <option disabled selected key="N" value="">U mjestu:</option>
                                    {towns.map(town => <option key={town} value={town}>{town}</option>)}
                                </select>
                                <label className="fw200 faded f12 margin-top-s" htmlFor="towns">Odaberi lokaciju</label>
                                <div className="row margin-top">
                                    <p onClick={prevRegScreen} className="text-left pointer form-p underline">{'<< Povratak'}</p>
                                    {(townBorder === 'MediumAquaMarine' || townBorder === 'orange') && (
                                        <p onClick={nextRegScreen} className="text-left pointer form-p margin-left underline mediumaquamarine">
                                            {'Nastavi >>'}
                                        </p>
                                    )}
                                </div>
                            </div>
                        }

                        {regScreen === 6 &&
                            <div>
                                <div ref={lastLocation} className="margin-top checkbox-wrap margin-bottom">
                                    <input
                                        type="checkbox"
                                        id="checkbox"
                                        name="checkbox"
                                        checked={checkBox}
                                        onChange={handleSetCheckbox}
                                    />
                                    <label htmlFor="checkbox" className="fw200 margin-left form-p noselect">Pročitao sam <span onClick={handleOpenModal}>uvodnik autora</span></label>

                                </div>

                                <div className="row middle space-between">
                                    {!isInMatchmaking && <button disabled={checkFields()} className="content-button" type="submit">Uđi u matchmaking</button>}
                                    {isInMatchmaking && <button onClick={handleMMUpdate} disabled={checkFields()} className="content-button" type="submit">Izmjeni postavke</button>}
                                </div>
                                <div className="row margin-top">
                                    {checkFields() && <p onClick={prevRegScreen} className="text-left pointer form-p margin-top margin-bottom underline">{'<< Povratak'}</p>}
                                    {!checkFields() && <p onClick={prevRegScreen} className="text-left pointer form-p margin-top margin-bottom underline">{'<< Želite ispravit podatke?'}</p>}
                                </div>
                            </div>
                        }
                    </div>
                    <div className="row w100 right">
                        {isInMatchmaking && <p onClick={handleLeaveMMNew} className="margin-left form-p pointer underline margin-right orange">Želiš li izaći iz matchamkinga? Klikni ovdje.</p>}
                    </div>
                </form>
            </div>
        )
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {renderMMNew()}
                </div>

            </div>
        </div>
    )
}

export default MM